(function () {
  function init(s) {
    if (s.dataset.dnInit) return;
    s.dataset.dnInit = '1';
    var wrap = s.parentNode;
    var tr = s.querySelector('.dn-track');
    if (!tr || !tr.children.length) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var looping = !reduce;
    if (looping) {
      [].slice.call(tr.children).forEach(function (n) {
        var c = n.cloneNode(true);
        c.setAttribute('aria-hidden', 'true');
        c.tabIndex = -1;
        tr.appendChild(c);
      });
    }
    var v = (parseInt(s.dataset.speed, 10) || 2) * 30;
    var last = null, paused = reduce, pos = 0, rs;
    var down = false, sx = 0, sl = 0, moved = false;
    function half() { return tr.scrollWidth / 2; }
    function loop(ts) {
      if (last !== null && !paused) {
        pos += v * (ts - last) / 1000;
        if (pos >= half()) pos -= half();
        s.scrollLeft = pos;
      }
      last = ts;
      requestAnimationFrame(loop);
    }
    function hold() { paused = true; clearTimeout(rs); }
    function rel(delay) {
      clearTimeout(rs);
      if (!looping) return;
      rs = setTimeout(function () { pos = s.scrollLeft; paused = false; }, delay || 1500);
    }
    wrap.addEventListener('mouseenter', hold);
    wrap.addEventListener('mouseleave', function () { if (!down) rel(1500); });
    s.addEventListener('touchstart', hold, { passive: true });
    s.addEventListener('touchend', function () { rel(1500); }, { passive: true });
    s.addEventListener('scroll', function () {
      if (looping && paused) {
        var d = 0;
        if (s.scrollLeft >= half()) d = -half();
        else if (s.scrollLeft <= 0) d = half();
        if (d) { s.scrollLeft += d; sl += d; }
      }
    });
    function step(dir) {
      var card = tr.children[0];
      var w = card ? card.getBoundingClientRect().width + 4 : 300;
      hold();
      if (looping && dir < 0 && s.scrollLeft <= 0) s.scrollLeft += half();
      s.scrollBy({ left: dir * w * 2, behavior: 'smooth' });
      rel(3000);
    }
    var bp = wrap.querySelector('.dn-sa.prev');
    var bn = wrap.querySelector('.dn-sa.next');
    if (bp) bp.addEventListener('click', function () { step(-1); });
    if (bn) bn.addEventListener('click', function () { step(1); });
    s.addEventListener('mousedown', function (e) {
      if (e.button !== 0) return;
      down = true; moved = false; sx = e.pageX; sl = s.scrollLeft;
      hold();
      s.classList.add('drag');
    });
    window.addEventListener('mousemove', function (e) {
      if (!down) return;
      var dx = e.pageX - sx;
      if (Math.abs(dx) > 4) moved = true;
      s.scrollLeft = sl - dx;
    });
    window.addEventListener('mouseup', function () {
      if (!down) return;
      down = false;
      s.classList.remove('drag');
      rel(1500);
    });
    s.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);
    s.addEventListener('dragstart', function (e) { e.preventDefault(); });
    requestAnimationFrame(loop);
  }
  function all() { [].forEach.call(document.querySelectorAll('.dn-strip'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all);
  else all();
  document.addEventListener('shopify:section:load', all);
})();